import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  return (
    <section className="py-10 md:py-20 bg-gradient-to-br from-background-100 via-primary-50/20 to-accent-50/20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <p className="text-xs md:text-sm text-primary-600 font-medium mb-2 md:mb-3 flex items-center justify-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500" />
            Reseñas reales en Google
          </p>
          <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-foreground-950 font-heading">
            ⭐ 4.9/5 · 287 opiniones de clientes en Málaga
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-background-50 rounded-2xl p-5 md:p-8 border border-background-200/60 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img alt={t.name} className="w-full h-full object-cover" loading="lazy" src={t.image} />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.source}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-400 text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed italic">&ldquo;{t.text}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}